import IconButton from "@material-ui/core/IconButton";
import React from "react";
import { withStyles, responsiveFontSizes } from "@material-ui/core/styles";

const CustomIconButton = ({ classes, size, style, ...props }) => (
  <IconButton className={`${classes[size]} ${style}`} {...props} />
);

const styles = {
  small: {
    "& svg": {
      fontSize: 18,
    },
    color: "#555A6C",
    marginRight: 30,
   " &:focus ":{
      outline: "none"
    }
  },
  medium: {
    "& svg": {
      fontSize: 24,
    },
    color: "#555A6C",
    marginRight: 30,
    " &:focus ":{
      outline: "none"
    }
  },
  large: {
    "& svg": {
      fontSize: 32,
    },
    color: "#555A6C",
    marginRight: 30,
    " &:focus ":{
      outline: "none"
    },
  },
};

export default withStyles(styles)(CustomIconButton);
